import { BoundedContent } from '@vp/swan';

export type TrustpilotWidgetProps = {
    locale: string;
    templateID?: string;
    businessUnitID?: string;
    styleHeight?: string;
    styleWidth?: string;
    tags?: string;
    stars?: string;
};

export function TrustpilotWidget({
    locale = 'en-US',
    templateID = '539adbd6dec7e10e686debee',
    businessUnitID = '56839d060000ff0005871345',
    styleHeight = '500px',
    styleWidth = '100%',
    tags = 'CDO',
    stars = '1,2,3,4,5',
}: TrustpilotWidgetProps) {
    // Inital rollout in en-AU
    const localeToURL = new Map<string, string>([
        ['en-AU', 'https://au.trustpilot.com/review/vistaprint.com.au'],
        // ['en-GB', 'https://uk.trustpilot.com/review/www.vistaprint.co.uk'],
        // ['en-US', 'https://www.trustpilot.com/review/www.vistaprint.com'],
        // ['en-US', 'https://www.trustpilot.com/review/www.vistaprint.com'],
        // ['de-AT', 'https://at.trustpilot.com/review/vistaprint.at'],
        // ['nl-BE', 'https://nl-be.trustpilot.com/review/vistaprint.be']
    ]);

    if (!localeToURL.get(locale)) {
        return null;
    }

    return (
        <BoundedContent>
            <div
                className="trustpilot-widget"
                data-locale={locale}
                data-template-id={templateID}
                data-businessunit-id={businessUnitID}
                data-style-height={styleHeight}
                data-style-width={styleWidth}
                data-tags={tags}
                data-stars={stars}
                data-review-languages={locale.split('-')[0]}
            >
                <a href={localeToURL.get(locale)} target="_blank" rel="noopener noreferrer">
                    Trustpilot
                </a>
            </div>
        </BoundedContent>
    );
}
